module.exports = __webpack_public_path__ + "img/coindesk.4d8cb2c8.png";